import { iAsin } from "../../../../types/campaigns"
import { metrics } from "../../types/table"
import { campaignStates } from "../../../../types/campaigns"
import { ILimitedCPC } from "../../../../types/limitedCPC"
import { ISettings } from "../../../../types/settings"
import { ITarget } from "../../types/table"

export enum SponsoredProductActionType {
  FETCH_SPONSORED_PRODUCTS_CAMPAIGNS = "SP/FETCH_SPONSORED_PRODUCTS",
  FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS = "SP/FETCH_SPONSORED_PRODUCTS_SUCCESS",
  FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR = "SP/FETCH_SPONSORED_PRODUCTS_ERROR",
}

interface FetchSponsoredProducts {
  type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS
}

interface FetchSponsoredProductsSuccess {
  type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS
  payload: ICampaignData
}

interface FetchSponsoredProductsError {
  type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR
  payload: string
}

export type SponsoredProductAction =
  | FetchSponsoredProducts
  | FetchSponsoredProductsSuccess
  | FetchSponsoredProductsError

export interface ICampaign extends metrics {
  _id: string
  profileId: number
  currencyCode: string
  campaignId: number
  campaignName: string
  campaignStatus: campaignStates
  keywordBid: number
  totalOrders: number
  isManage: boolean
  keywordText: string
  asins: iAsin[]
  organicPosition: number
  last_scraped_at: string | null
  createdAt: string
  updatedAt: string
  __v: number
  targets: ITarget[]
}

export interface ICampaignData {
  campaigns: ICampaign[]
  settings: ISettings | null
  limitedCPC: ILimitedCPC | null
  targetAcos: number | 0
  lastDateWithoutData: string
}

export interface SponsoredProductState {
  campaignData: ICampaignData
  loading: boolean
  error: null | string
}
